"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Trybe
 * This site provides documentation on how to use the Trybe Shop API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var _1 = require("./");
function ListUsers1FromJSON(json) {
    return ListUsers1FromJSONTyped(json, false);
}
exports.ListUsers1FromJSON = ListUsers1FromJSON;
function ListUsers1FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'data': (json['data'].map(_1.User1FromJSON)),
        'meta': _1.PaginationMetaFromJSON(json['meta']),
        'links': _1.PaginationLinksFromJSON(json['links']),
    };
}
exports.ListUsers1FromJSONTyped = ListUsers1FromJSONTyped;
function ListUsers1ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'data': (value.data.map(_1.User1ToJSON)),
        'meta': _1.PaginationMetaToJSON(value.meta),
        'links': _1.PaginationLinksToJSON(value.links),
    };
}
exports.ListUsers1ToJSON = ListUsers1ToJSON;
